import {Component, Inject, OnInit} from '@angular/core';
import {TestLink} from '../../../data/models/test-link';
import {TestLinkService} from '../../../services/api/test-link.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-link-delete-dialog',
  templateUrl: './test-link-delete-dialog.component.html',
  styleUrls: ['./test-link-delete-dialog.component.css']
})
export class TestLinkDeleteDialogComponent implements OnInit {

  testId: number;
  testLink: TestLink;

  constructor(
    private testLinkService: TestLinkService,
    public dialogRef: MatDialogRef<TestLinkDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testId: number,
      testLink: TestLink,
    },
  ) {
    this.testId = data.testId;
    this.testLink = data.testLink;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testLinkService.deleteTestLink(this.testId, this.testLink.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
